import { useState, useEffect } from 'react';
import axios from 'axios';
import routes from 'app/routes';

export default function usePolicyTemplates() {
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.policy_templates.index)
      .then((resp) => {
        setLoading(false);
        setTemplates(resp.data.data);
      });
  }, []);

  return { loading, templates };
}
